module.exports = __webpack_public_path__ + "img/Voie_Eau.b083079b.png";